import React from "react";
import { connect } from "react-redux";
import Layout from "../../components/layout";
import { Helmet } from "react-helmet";
import ComissionsReactivationReportPage from "../../components/comissionsReactivationReport";
import {
  getReactivationComissionsReport,
  clearReactivationComissionsReport,
  getPastPeriods,
  authorizeMemberships
} from "../../actions/reports";
import { getClubs, getSchemas, getSellers } from "../../actions/catalogs";
import { getPeriodById } from "../../actions/periods";
import { FILTERS } from "../../components/comissionsReactivationReport/interfaces";
import moment from "moment";
const PAST_PERIODS_TO_GET = 30;

interface Props {
  clubs: object;
  periods: object;
  periodById: object;
  reportReactivationComissions: object[];
  sellers: object[];
  schemas: object[];
  getClubs: () => any;
  getSchemas: () => any;
  getPastPeriods: (limite: string, cantidad: number) => any;
  getSellers: () => any;
  getReactivationComissionsReport: (filters: FILTERS) => void;
  clearReactivationComissionsReport: () => void;
  getPeriodById: (idPeriodo: number) => void;
  authorizeMemberships: (comissionsList: object) => void;
}

interface State {}

class ComissionsReactivationReport extends React.Component<Props, State> {
  state = {};

  componentDidMount() {
    this.props.getSchemas();
    this.props.getClubs();
    this.props.getPastPeriods(
      moment()
        .add(20, "days")
        .format("YYYY-MM-DD"),
      PAST_PERIODS_TO_GET
    );
    this.props.getSellers();
    this.props.clearReactivationComissionsReport();
  }

  componentDidUpdate() {}

  seterNameToSchemas = () => {
    let schemasCal = [];
    if (this.props.periodById && this.props.schemas) {
      this.props.periodById["esquemasAplicables"].forEach(element => {
        this.props.schemas.forEach(item => {
          if (element.esquemaId === item["esquemaId"]) schemasCal.push(item);
        });
      });
      return schemasCal;
    }
    return null;
  };

  render() {
    return (
      <main>
        <Helmet title="Reporte de comisiones de reactivación" />
        <Layout>
          {this.props.clubs && this.props.periods && (
            <ComissionsReactivationReportPage
              fetchSearchData={this.props.getReactivationComissionsReport}
              getSchemasByPeriod={this.props.getPeriodById}
              clubs={this.props.clubs}
              periods={this.props.periods}
              schemas={this.seterNameToSchemas()}
              reportComissions={this.props.reportReactivationComissions}
              sellers={this.props.sellers}
              authorizeMemberships={this.props.authorizeMemberships}
            />
          )}
        </Layout>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getClubs: () => {
    return dispatch(getClubs());
  },
  getPastPeriods: (limite, cantidad) => {
    return dispatch(getPastPeriods(limite, cantidad));
  },
  getSchemas: () => {
    return dispatch(getSchemas());
  },
  getPeriodById: idPeriodo => {
    return dispatch(getPeriodById(idPeriodo));
  },
  getReactivationComissionsReport: (filters: FILTERS) => {
    return dispatch(getReactivationComissionsReport(filters));
  },
  clearReactivationComissionsReport: () => {
    return dispatch(clearReactivationComissionsReport());
  },
  getSellers: () => {
    return dispatch(getSellers());
  },
  authorizeMemberships: (comissionsList: object) => {
    return dispatch(authorizeMemberships(comissionsList));
  }
});

const mapStateToProps = state => {
  const {
    catalogs: { clubs, sellers, schemas },
    periods: { periods, periodById },
    reports: { reportReactivationComissions, loadingReport }
  } = state;
  return {
    clubs,
    schemas,
    periods,
    periodById,
    sellers,
    reportReactivationComissions,
    loadingReport
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ComissionsReactivationReport);
